import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "../style/Login.css";
import { AuthContext } from '../App';
import { Modal } from "react-bootstrap";
import { apiFetchJson } from "../api";



const PasswordChange = ( { force, dbName, open, onClose }) => {

    const { state: authState, dispatch: authDispatch } = React.useContext(AuthContext);
    const [data, setData] = useState({
        password: "",
        password2: "",
        isSubmitting: false,
    });
    const [isValid, setIsValid] = useState(false);
    const [isMatching, setIsMatching] = useState(false);


    const handleInputChange = event => {
        setData({
            ...data,
            [event.target.name]: event.target.value,
        });
    };

    useEffect(() => {
        if (data.password.length > 7) {
            setIsValid(true);
        }
        else {
            setIsValid(false);
        }
        if (data.password && data.password === data.password2) {
            setIsMatching(true);
        }
        else {
            setIsMatching(false);
        }
    }, [data]);


    const handleCancel = event => {
        console.log('Cancel');
        onClose(false);
    }

    const handleFormSubmit = event => {
        event.preventDefault();
        setData({
            ...data,
            isSubmitting: true,
            errorMessage: null
        });
        apiFetchJson("api/updatePassword/"+dbName+"/"+authState.user.id, {
            method: "post",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                password: data.password
            })
        }).then(data => {
            console.log('Return from password update');
            authDispatch({
                type: "UPDATE",
                payload: data
            });
            onClose(false);
        })
        .catch(error => {
            console.log(error);
        })
    };


    return (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={open}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton={false}>
                <Modal.Title>Update password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="passwordEnter">
                        <Form.Label>New password</Form.Label>
                        <Form.Control
                            type="password"
                            autoFocus
                            onChange={handleInputChange}
                            name="password"
                            value={data.password || ''}
                        />
                        <Form.Label>Repeat password</Form.Label>
                        <Form.Control
                            type="password" 
                            onChange={handleInputChange}
                            name="password2"
                            value={data.password2 || ''}
                        />
                    </Form.Group>
                </Form>
                {!isValid && <span>Password less than 8 characters</span>}
                {isValid && !isMatching && <span>Passwords not matching</span>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel} disabled={force}>
                    {force ? "Must update on first use" : "Cancel" }
                </Button>
                <Button variant="primary"  onClick={handleFormSubmit} disabled={!(isValid && isMatching)}>
                    Submit
                </Button>
            </Modal.Footer>

        </Modal>
    );
}

export default PasswordChange;
